import {Component, inject, OnInit} from "@angular/core";
import {Store} from "@ngrx/store";
import {FormBuilder, Validators} from "@angular/forms";
import {DateUtil} from "../../../shared/utils/date-util";
import {numberNotBiggerThan190000m} from "../../../shared/utils/form-validators";
import {selectNetCurrentAssetForecast} from "../../store/fund-valuation/fund-valuation.selectors";
import {map} from "rxjs";
import {DecimalFormatPipe} from "../../../shared/pipes/decimal-format/decimal-format.pipe";
import {FundValuationActions} from "../../store/fund.actions";
import {take} from "rxjs/operators";

@Component({
    selector: "valumize-net-current-asset-dialog",
    standalone: false,
    templateUrl: "./net-current-asset-dialog.component.html",
})
export class NetCurrentAssetDialogComponent implements OnInit {
    private readonly store = inject(Store);
    fundValuationsForFundReport$ = this.store.select(selectNetCurrentAssetForecast);
    private readonly formBuilder = inject(FormBuilder);
    ncaForm = this.formBuilder.group({
        exitDateAssumption: this.formBuilder.control<Date>(DateUtil.jsDate(), {nonNullable: true, validators: Validators.required}),
        lowNca: this.formBuilder.control<number | null>(null, {validators: [numberNotBiggerThan190000m(), Validators.required]}),
        baseNca: this.formBuilder.control<number | null>(null, {validators: [numberNotBiggerThan190000m(), Validators.required]}),
        highNca: this.formBuilder.control<number | null>(null, {validators: [numberNotBiggerThan190000m(), Validators.required]}),
    })

    ngOnInit(): void {
        this.fundValuationsForFundReport$.pipe(
            take(1),
            map(nca =>
                this.ncaForm.patchValue({
                    exitDateAssumption: DateUtil.toJsDate(nca.exitDate),
                    lowNca: DecimalFormatPipe.transformFromMillionsNum(nca.lowNca),
                    baseNca: DecimalFormatPipe.transformFromMillionsNum(nca.baseNca),
                    highNca: DecimalFormatPipe.transformFromMillionsNum(nca.highNca),
                })
            ),
        ).subscribe();
    }

    save() {
        if (this.ncaForm.valid) {
            const formValues = this.ncaForm.getRawValue();
            this.store.dispatch(FundValuationActions.saveNca({
                exitDate: DateUtil.toIsoDate(formValues.exitDateAssumption) as string,
                lowNca: DecimalFormatPipe.transformToMillionsNum(formValues.lowNca) ?? 0,
                baseNca: DecimalFormatPipe.transformToMillionsNum(formValues.baseNca) ?? 0,
                highNca: DecimalFormatPipe.transformToMillionsNum(formValues.highNca) ?? 0,
            }));
        }
    }
}
